import { render, staticRenderFns } from "./ChallengeMatch.vue?vue&type=template&id=19a8d5ba&scoped=true"
import script from "./ChallengeMatch.vue?vue&type=script&lang=js"
export * from "./ChallengeMatch.vue?vue&type=script&lang=js"
import style0 from "./ChallengeMatch.vue?vue&type=style&index=0&id=19a8d5ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8d5ba",
  null
  
)

export default component.exports